/* eslint-disable vue/no-unused-vars */
<template>
  <div class="flex flex-row text-grey-darker mb-1 items-center text-sm h pl-2">
    <div class="font-bold w-24">
      Schwierigkeit:
    </div>
    <div
      class="flex flex-row ml-2"
      :class="colorDifficulty()"
    >
      <div
        v-for="i in difficulty"
        :key="i"
      >
        <i
          style="margin: 0.125rem"
          class="text-xs fas fa-square"
        />
      </div>
      <div
        v-for="i in emptyDifficultSquares()"
        :key="i"
      >
        <i
          style="margin: 0.125rem"
          class="text-xs far fa-square text-gray-400"
        />
      </div>
      <div class="ml-2">
        {{ textDifficulty() }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Difficulty',
    props: {

        difficulty: {
            type: Number,
            required: false
        }
    },
    methods: {
        colorDifficulty () {
            if (this.difficulty < 3) {
                return 'text-green-600'
            } else if (this.difficulty === 3) {
                return 'text-yellow-600'
            } else if (this.difficulty === 4) {
                return 'text-red-600'
            }
        },
        textDifficulty () {
            if (this.difficulty === 1) {
                return 'Anfänger'
            } else if (this.difficulty === 2) {
                return 'Leicht'
            } else if (this.difficulty === 3) {
                return 'Mittel'
            } else if (this.difficulty === 4) {
                return 'Schwer'
            }
        },
        emptyDifficultSquares () {
            return 4 - this.difficulty
        }
    }
}
</script>

<style scoped>

</style>